import React from 'react';
import ProductCodeContainer from '../../common/components/code-container/components/product-code-container';
import { setHomePage } from '../../common/components/emerald-home-page/emerald-home-page';
import Keypad from '../../keypad/components/keypad';
import { ScannedDataHandler } from '../../devices/scanner-operations';
import BottleDepositReturnWindow from './bottle-deposit-return-window';
import { useTranslation } from 'react-i18next';
import TenderAmountDue from 'src/tendering/components/tender-amount-due';
import { AppState } from 'src/common/redux/configure-store';
import { useSelector } from 'react-redux';
import { EJRecordTypes } from 'src/common/enumerations/ej-record-types';
import { getProductCount } from 'src/total/business-logic/product-count';

type Props = IBottleDepositProps;

export const showBottleDepositContainer = (props: Props, onScan: ScannedDataHandler): void => {
  setHomePage(<BottleDepositContainer {...props} />, onScan);
};

export const BottleDepositContainer: React.FC<Props> = (props: Props): JSX.Element => {
  const { t } = useTranslation();
  const { amountDue, ejItems } = useSelector((state: AppState) => state.itemList);
  const itemsReturnedInCurrentTransaction = ejItems.filter(
    i => i.Type === EJRecordTypes.ReturnItem && !i.Voided,
  );
  const keypad = (
    <Keypad
      keyboardId={'bottle-deposit-item-code'}
      visible
      keypadTestIdPrefix={'bottle-deposit-item-code-'}
      topLabelText={t('EnterBottleCode')}
      submitButton={{
        label: t('Ok'),
        onClick: props.onItemCodeReceived,
      }}
      disableManualWeight={true}
      disableQuantity={true}
      disableDecimalInput={true}
    />
  );
  const totalCount = getProductCount(itemsReturnedInCurrentTransaction, true);
  const totalComponent = (
    <TenderAmountDue
      amountDue={amountDue}
      totalLabel={`${totalCount} ${t(totalCount === 1 ? 'item' : 'items')}`}
      align='right'
    />
  );
  const totalComponentProps = amountDue ? { titleSubContainerComponent: totalComponent } : {};
  return (
    <ProductCodeContainer
      headerTitle={t('Bottle_Deposit_Header')}
      onKeypadSubmit={props.onItemCodeReceived}
      keypadComponent={keypad}
      headerSubTitle={t('BottleReturnInstructionalText')}
      {...totalComponentProps}
    >
      <BottleDepositReturnWindow
        onAdd={props.onItemCodeReceived}
        onCancel={props.onCancel}
        onFinish={props.onFinish}
        itemsReturnedInCurrentTransaction={itemsReturnedInCurrentTransaction}
      />
    </ProductCodeContainer>
  );
};

export interface IBottleDepositProps {
  onFinish: () => void;
  onCancel: () => void;
  onItemCodeReceived: (itemId: string) => void;
}
